import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58719e3d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "guest-sign-in-form" }
const _hoisted_2 = { class: "guest-button-wrap" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Back")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("Continue")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Input = _resolveComponent("Input")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Input, {
      modelValue: _ctx.guestName,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.guestName) = $event)),
      onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.emitSubmit()), ["enter"])),
      label: "Enter your name",
      placeholder: "Your Name"
    }, null, 8, ["modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        class: "button-alternative",
        width: "fill-container",
        mode: "outlined",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.emitClose()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }),
      _createVNode(_component_Button, {
        class: "button-alternative",
        width: "fill-container",
        disabled: !_ctx.guestName || _ctx.inProgress,
        loading: _ctx.inProgress,
        hideText: _ctx.inProgress,
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.emitSubmit()))
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled", "loading", "hideText"])
    ])
  ]))
}